<div id="home" style="text-align: center;height: 100%;width: 100%;">


  <div id="hello" *ngIf="usernameARR.displayName!=null" class="animate__animated animate__heartBeat">
    <p>Hello, {{usernameARR.displayName}}</p>

  </div>
  <div id="hello1" *ngIf="usernameARR.displayName==null" class="animate__animated animate__heartBeat">
    <p>Hello, {{usernameARR.email}}</p>

  </div>

  <div id="paypal1">
    <ngx-paypal [config]="payPalConfig"></ngx-paypal>
    <h2 style="font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;">Fanan team Majoris pack price -
      8$</h2>
    <div *ngIf="checkSerials[0]">

      <div *ngFor="let i of checkSerials">
        <div *ngIf="i.Serial">
          <b style="font-size: 35px;color: red;">Your serial is:
            <br> {{i.Serial}}
            <br>
            {{paramsID}}
          </b>

        </div>
      </div>
    </div>
  </div>
